function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Button, Checkbox, CheckboxGroup, Divider, Flex, HStack, ModalBody, Popover, PopoverContent, PopoverTrigger, Portal, Slider, SliderFilledTrack, SliderThumb, SliderTrack, Stack, Text } from '@chakra-ui/react';
import { GiveawaySteps, GiveawayType } from '@/types/client';
import GiveawayModalHeader from './GiveawayModalHeader';
import { GiveawayModalContext } from './GiveawayModalContext';
import useGiveawayStore from '@/stores/GiveawayStore';
import useChannelStore from '@/stores/ChannelStore';
import { AuthProviders, UserLevels } from '@/types/server';
import { LuckBasedGiveaways } from '@/utils/constants';
import { useShallow } from 'zustand/react/shallow';
function CheckboxCard(_param) {
    var title = _param.title, description = _param.description, luck = _param.luck, setLuck = _param.setLuck, props = _object_without_properties(_param, [
        "title",
        "description",
        "luck",
        "setLuck"
    ]);
    var intl = useIntl();
    var ref = React.useRef(null);
    return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsx(Checkbox, _object_spread_props(_object_spread({}, props), {
                paddingX: 4,
                paddingY: 3,
                borderRadius: "lg",
                borderWidth: "1px",
                colorScheme: "primary",
                width: "100%",
                backgroundColor: "whiteAlpha.50",
                borderColor: "borderSecondary",
                _checked: {
                    bg: 'primaryAlpha.300',
                    borderColor: 'primary.600'
                },
                children: /*#__PURE__*/ _jsxs(Flex, {
                    alignItems: "center",
                    flex: 1,
                    children: [
                        /*#__PURE__*/ _jsxs(Stack, {
                            spacing: 0,
                            marginLeft: 2,
                            flex: 1,
                            width: "100%",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    fontSize: "sm",
                                    color: "textSecondary",
                                    children: description
                                })
                            ]
                        }),
                        setLuck != null ? /*#__PURE__*/ _jsxs(Popover, {
                            placement: "bottom",
                            children: [
                                /*#__PURE__*/ _jsx(PopoverTrigger, {
                                    children: /*#__PURE__*/ _jsxs(Button, {
                                        minWidth: "50px",
                                        size: "sm",
                                        marginLeft: "auto",
                                        "aria-label": intl.formatMessage({
                                            id: "R9SWtw",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Change Number of Entries"
                                                }
                                            ]
                                        }),
                                        children: [
                                            luck,
                                            "x"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Portal, {
                                    containerRef: ref,
                                    children: /*#__PURE__*/ _jsx(PopoverContent, {
                                        padding: 2,
                                        paddingX: 4,
                                        width: "240px",
                                        backgroundColor: "backgroundPrimary",
                                        borderColor: "borderSecondary",
                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ _jsx(Text, {
                                                    size: "sm",
                                                    textAlign: "center",
                                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                                        id: "7/8I0T",
                                                        defaultMessage: "{luck, plural, one {# Entry} other {# Entries}}",
                                                        values: {
                                                            luck: luck
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs(Slider, {
                                                    min: 0,
                                                    max: 10,
                                                    step: 1,
                                                    value: luck,
                                                    onChange: function(value) {
                                                        return setLuck(Math.max(1, value));
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx(SliderTrack, {
                                                            children: /*#__PURE__*/ _jsx(SliderFilledTrack, {})
                                                        }),
                                                        /*#__PURE__*/ _jsx(SliderThumb, {})
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            })),
            /*#__PURE__*/ _jsx("span", {
                ref: ref
            })
        ]
    });
}
function GiveawayUserEllibility() {
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useContext = React.useContext(GiveawayModalContext), onClose = _React_useContext.onClose, setStep = _React_useContext.setStep;
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            eligibility: state.eligibility,
            luck: state.luck,
            setLuck: state.setLuck,
            setEligibility: state.setEligibility,
            type: state.type
        };
    })), eligibility = _useGiveawayStore.eligibility, luck = _useGiveawayStore.luck, setLuck = _useGiveawayStore.setLuck, setEligibility = _useGiveawayStore.setEligibility, type = _useGiveawayStore.type;
    var handleNext = React.useCallback(function() {
        switch(type){
            case GiveawayType.ACTIVE_USER:
                setStep(GiveawaySteps.ACTIVE_SETTINGS);
                break;
            case GiveawayType.RANDOM_NUMBER:
                setStep(GiveawaySteps.RANDOM_NUMBER_SETTINGS);
                break;
            case GiveawayType.KEYWORD:
                setStep(GiveawaySteps.KEYWORD_SETTINGS);
                break;
        }
    }, [
        setStep,
        type
    ]);
    var subscriberCheckboxTitle = (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.YOUTUBE ? intl.formatMessage({
        id: "/mYICv",
        defaultMessage: [
            {
                type: 0,
                value: "Channel Members"
            }
        ]
    }) : intl.formatMessage({
        id: "u4eb+l",
        defaultMessage: [
            {
                type: 0,
                value: "Subscribers"
            }
        ]
    });
    var subscriberCheckboxDescription = (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.YOUTUBE ? intl.formatMessage({
        id: "qpILAw",
        defaultMessage: [
            {
                type: 0,
                value: "Channel Members can enter the giveaway."
            }
        ]
    }) : intl.formatMessage({
        id: "jR9H7L",
        defaultMessage: [
            {
                type: 0,
                value: "Subscribers can enter the giveaway."
            }
        ]
    });
    return /*#__PURE__*/ _jsxs(ModalBody, {
        padding: 0,
        children: [
            /*#__PURE__*/ _jsx(GiveawayModalHeader, {
                title: intl.formatMessage({
                    id: "BPo08y",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Who can Enter?"
                        }
                    ]
                }),
                onClose: onClose
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsx(Stack, {
                spacing: 6,
                padding: 6,
                children: /*#__PURE__*/ _jsxs(CheckboxGroup, {
                    value: eligibility,
                    onChange: function(value) {
                        return setEligibility(value);
                    },
                    children: [
                        /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "37mth/",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Viewers"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "HI+bzt",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Viewers can enter the giveaway."
                                    }
                                ]
                            }),
                            value: UserLevels.EVERYONE,
                            luck: LuckBasedGiveaways.has(type) ? luck[UserLevels.EVERYONE] : 0,
                            setLuck: LuckBasedGiveaways.has(type) ? function(value) {
                                return setLuck(UserLevels.EVERYONE, value);
                            } : undefined
                        }),
                        /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "o458GP",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Regulars"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "+fUw+t",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Regulars can enter the giveaway."
                                    }
                                ]
                            }),
                            value: UserLevels.REGULAR,
                            luck: LuckBasedGiveaways.has(type) ? luck[UserLevels.REGULAR] : 0,
                            setLuck: LuckBasedGiveaways.has(type) ? function(value) {
                                return setLuck(UserLevels.REGULAR, value);
                            } : undefined
                        }),
                        (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.TWITCH ? /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "g4byOr",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "VIPs"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "r5gjNS",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "VIPs can enter the giveaway."
                                    }
                                ]
                            }),
                            value: UserLevels.TWITCH_VIP,
                            luck: LuckBasedGiveaways.has(type) ? luck[UserLevels.TWITCH_VIP] : 0,
                            setLuck: LuckBasedGiveaways.has(type) ? function(value) {
                                return setLuck(UserLevels.TWITCH_VIP, value);
                            } : undefined
                        }) : null,
                        (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.SOOP ? /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "g4byOr",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "VIPs"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "r5gjNS",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "VIPs can enter the giveaway."
                                    }
                                ]
                            }),
                            value: UserLevels.SOOP_VIP,
                            luck: LuckBasedGiveaways.has(type) ? luck[UserLevels.SOOP_VIP] : 0,
                            setLuck: LuckBasedGiveaways.has(type) ? function(value) {
                                return setLuck(UserLevels.SOOP_VIP, value);
                            } : undefined
                        }) : null,
                        /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: subscriberCheckboxTitle,
                            description: subscriberCheckboxDescription,
                            value: UserLevels.SUBSCRIBER,
                            luck: LuckBasedGiveaways.has(type) ? luck[UserLevels.SUBSCRIBER] : 0,
                            setLuck: LuckBasedGiveaways.has(type) ? function(value) {
                                return setLuck(UserLevels.SUBSCRIBER, value);
                            } : undefined
                        }),
                        /*#__PURE__*/ _jsx(CheckboxCard, {
                            title: intl.formatMessage({
                                id: "qP6RWY",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Moderators"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "mEMOQR",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Moderators can enter the giveaway."
                                    }
                                ]
                            }),
                            value: UserLevels.MODERATOR,
                            luck: LuckBasedGiveaways.has(type) ? luck[UserLevels.MODERATOR] : 0,
                            setLuck: LuckBasedGiveaways.has(type) ? function(value) {
                                return setLuck(UserLevels.MODERATOR, value);
                            } : undefined
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                spacing: 6,
                p: 6,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        onClick: function() {
                            return setStep(GiveawaySteps.TYPE);
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "cyR7Kh",
                            defaultMessage: "Back"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        variant: "cta",
                        onClick: function() {
                            return handleNext();
                        },
                        isDisabled: eligibility.length === 0,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "9+Ddtu",
                            defaultMessage: "Next"
                        })
                    })
                ]
            })
        ]
    });
}
export default GiveawayUserEllibility;
